// import { getCVData as getGovCVData } from './components/gov-cv/business';
import { getCVData as getGovCVData } from './components/cv-2022/business-gov-cv';
import { getCVData as getPromCVData } from './components/prom-cv/business';
import './i18n/index';
import { EScene } from './config';

let gScene: EScene = EScene.empty;  // 未知
let gBiPrefix = 'promotion.undefined'; // BI上报前缀
let gBiPage = 'hkcv';  // BI上报第3段
let gBiExt = {}; // BI 拓展

/**
 * 引用组件前都要调init
 * @param scene 场景
 */
export async function init(scene: EScene = EScene.empty, reflesh = false, isFreeze = false, isPreRegist = false) {
  await getGovCVData(reflesh, isFreeze);
  // await getPromCVData(reflesh, isFreeze);

  if (gScene === EScene.empty) {
    gScene = scene;
  }
  if (gScene === EScene.empty) {
    throw new Error('请传入场景{platform|act}，platform：homepage，act：活动页面');
  }
}

/**
 * 调用方场景
 */
export function getScene(): EScene {
  return gScene;
}


/**
 * 上报BI数据事件的前缀
 */
export function setBiReportPrefix(prefix: string, page = 'hkcv') {
  gBiPrefix = prefix || gBiPrefix;
  gBiPage = page || gBiPage;
}
export function setBiReportExt(param) {
  gBiExt = param || gBiExt;
}
/**
 * 获取BI上报事件前缀
 */
export function getBiReportPrefix(): {
  prefix: string;
  page: string;
} {
  return {
    prefix: gBiPrefix,
    page: gBiPage,
  };
}

export function getBiReportExt() {
  return gBiExt;
}
